export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-8" data-testid={testid || "page-header"}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="text-slate-400 text-sm mt-1.5 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
